import { render, staticRenderFns } from "./AcademicConsolidated.vue?vue&type=template&id=72c4f60c"
import script from "./AcademicConsolidated.vue?vue&type=script&lang=js"
export * from "./AcademicConsolidated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports